import { useEffect } from 'react';

export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://allchinabuyspread.wtf';

export const SITE_LOGO =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg';

export interface SeoInput {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  image?: string;
  lang?: string;
}

function normalizePath(path?: string): string {
  if (!path) return '/';
  if (path === '/') return '/';
  return path.startsWith('/') ? path : `/${path}`;
}

function upsertMetaByName(name: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertMetaByProperty(property: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function removeMeta(selector: string): void {
  document.head.querySelector(selector)?.remove();
}

export function useSeo({ title, description, keywords, path, image, lang }: SeoInput): void {
  useEffect(() => {
    const canonicalPath = normalizePath(path);
    const url = canonicalPath === '/' ? `${SITE_URL}/` : `${SITE_URL}${canonicalPath}`;

    document.title = title;
    upsertMetaByName('description', description);
    if (keywords) {
      upsertMetaByName('keywords', keywords);
    }
    upsertCanonical(url);

    upsertMetaByProperty('og:title', title);
    upsertMetaByProperty('og:description', description);
    upsertMetaByProperty('og:url', url);

    upsertMetaByName('twitter:title', title);
    upsertMetaByName('twitter:description', description);

    if (image) {
      upsertMetaByProperty('og:image', image);
      upsertMetaByName('twitter:image', image);
    } else {
      removeMeta('meta[property="og:image"]');
      removeMeta('meta[name="twitter:image"]');
    }

    if (lang) {
      document.documentElement.lang = lang;
    }
  }, [title, description, keywords, path, image, lang]);
}